import type { ISegment } from "@repo/baseCloud";

import { GridFiltersController } from "@repo/baseCloud";
import { FilterDropdown } from "@repo/ui";
import { useQuery } from "@tanstack/react-query";
import { ReactNode, useCallback } from "react";

import { QUERY_KEYS } from "../api/queries";

interface Props {
	value: number[];
	changeHandler: (value: number[], id: string) => void;
	label?: ReactNode;
	filters?: ISegment;
	id?: string;
}

export function MachinesDropdown(props: Props) {
	const { filters = {}, id = "machines" } = props;
	const machineFilters = {
		brands: filters.brandIds,
		channels: filters.channelIds,
		marketers: filters.marketerIds,
		states: filters.stateIds,
		branches: filters.branchIds,
		showInactiveOffices: filters.showInactiveOffices,
	};

	const machinesQuery = useQuery({
		queryKey: [QUERY_KEYS.Components.MachinesDropdown, machineFilters],
		queryFn: () => GridFiltersController.getMachines(machineFilters),
	});

	const changeHandler = useCallback((v: number[]) => props.changeHandler(v, id), [props.changeHandler, id]);

	return (
		<FilterDropdown
			{...props}
			id={id}
			allOption
			values={machinesQuery.data ?? []}
			loaded={!machinesQuery.isLoading}
			changeHandler={changeHandler}
			objectName="Machines"
			fullLength
			isMulti
		/>
	);
}
